import React from "react";
import { updateDataTableHeaderPosition } from "../helpers/updateDataTableHeaderPosition";

export interface UseDataTableFixedHeaderOptions {
  headerRef: React.MutableRefObject<HTMLTableSectionElement | null>;
  fixedHeaderRef: React.MutableRefObject<HTMLTableSectionElement | null>;
  tableRef: React.MutableRefObject<HTMLTableElement | null>;
  containerRef?: HTMLDivElement | null;
  gap?: number;
}

export const useDataTableFixedHeader = (
  options: UseDataTableFixedHeaderOptions
) => {
  const { headerRef, fixedHeaderRef, tableRef, containerRef, gap } = options;

  const _updateFixedHeaderColumnsSize = React.useCallback(() => {
    //updateFixedHeaderColumnsSize(headerRef.current, fixedHeaderRef.current);
  }, [headerRef, fixedHeaderRef]);

  React.useEffect(() => {
    if (!containerRef) return;

    const handleScroll = () => {
      updateDataTableHeaderPosition(
        (gap || 0) + 65, // table.headerGap,
        tableRef.current,
        headerRef.current,
        fixedHeaderRef.current
      );

      _updateFixedHeaderColumnsSize();
    };

    containerRef.addEventListener("scroll", handleScroll);
    containerRef.addEventListener("resize", handleScroll);
    handleScroll();

    setTimeout(() => {
      handleScroll();
      //updateHScroll();
    }, 100);
    return () => {
      containerRef.removeEventListener("scroll", handleScroll);
      containerRef.removeEventListener("resize", handleScroll);
    };
  }, [fixedHeaderRef, headerRef, tableRef, containerRef]);
};
